import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { putJSON } from 'api/fetch';
import { RootState } from 'initializers/types';

import {
  AddonCancellationSubmission,
  CANCEL_ADDONS_SLICE,
} from 'features/settings/CancelAddonsView/constants';

interface CancelAddonsState {
  isSubmitting: boolean;
  isCancelled: boolean;
  error: string | null;
}

const initialState: CancelAddonsState = {
  isSubmitting: false,
  isCancelled: false,
  error: null,
};

// THUNKS

export const submitAddonCancellation = createAsyncThunk(
  `${CANCEL_ADDONS_SLICE}/submitAddonCancellation`,
  async ({
    subscriptionId,
    reason,
    reasonElaboration,
  }: AddonCancellationSubmission) =>
    putJSON('/biller/product_subscriptions/cancel', {
      subscription_id: subscriptionId,
      reason,
      reason_elaboration: reasonElaboration,
    })
);

const cancelAddonsSlice = createSlice({
  name: CANCEL_ADDONS_SLICE,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(submitAddonCancellation.pending, state => {
        state.isSubmitting = true;
        state.isCancelled = false;
        state.error = null;
      })
      .addCase(submitAddonCancellation.fulfilled, state => {
        state.isSubmitting = false;
        state.isCancelled = true;
      })
      .addCase(submitAddonCancellation.rejected, (state, action) => {
        state.isCancelled = false;
        state.error =
          action &&
          action.payload &&
          typeof action.payload === 'object' &&
          action.payload !== null &&
          'message' in action.payload &&
          typeof (action?.payload).message === 'string'
            ? (action?.payload).message
            : 'Failed to cancel add-on subscription.';
      });
  },
});

// SELECTORS

export const selectCancelAddonsIsCancelled = (state: RootState) =>
  state.get('cancelAddons').isCancelled;

export const selectCancelAddonsIsSubmitting = (state: RootState) =>
  state.get('cancelAddons').isSubmitting;

export const selectCancelAddonsError = (state: RootState) =>
  state.get('cancelAddons').error;

export const { reducer, actions } = cancelAddonsSlice;
